import React from 'react';
import PropTypes from "prop-types";

const InputForm = (props) => {
    return (
        <div className={props.col || 'col-12'}>
            <div className="mb-20">
                <label
                    htmlFor={props.name}
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                    {props.label} {props.required && <span className="text-danger-600">*</span>}
                </label>
                <select
                    className={`form-control radius-8 form-select ${props.error?.[props.name] ? 'is-invalid' : ''}`}
                    name={props.name}
                    onChange={props.change || (() => {})}
                    value={props.datos ? props.datos[props.name] || '' : ''}
                >
                    <option value="" disabled>
                        Selecciona una opción
                    </option>
                    {props.options && props.options.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
                <div className="invalid-feedback">
                    {props.error?.[props.name]}
                </div>
            </div>
        </div>
    );
};

export default InputForm;

InputForm.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};